var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "finance-container" },
    [
      _c(
        "el-card",
        { staticClass: "search-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              attrs: {
                model: _vm.searchForm,
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("trajectory.Time"),
                            prop: "dateRange",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: "change",
                            },
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                              "start-placeholder": _vm.$t(
                                "GlobalSetObj.startDate"
                              ),
                              format: "yyyy-MM-dd HH:mm:ss",
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.searchForm.dateRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "dateRange", $$v)
                              },
                              expression: "searchForm.dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.client"),
                            prop: "customerId",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: "change",
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: { "visible-change": _vm.getCustomerOption },
                              model: {
                                value: _vm.searchForm.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "customerId", $$v)
                                },
                                expression: "searchForm.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "（" +
                                    item.username +
                                    "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.FundsCategory") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.fundCategory,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "fundCategory", $$v)
                                },
                                expression: "searchForm.fundCategory",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("basicData.recharge"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("basicData.Refund"),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t("basicData.Expense"),
                                  value: 3,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.FundsSubcategory"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.expenseCategory,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "expenseCategory",
                                    $$v
                                  )
                                },
                                expression: "searchForm.expenseCategory",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("basicData.PlaceQuoteBilling"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t(
                                    "basicData.OrderFeeRecalculation"
                                  ),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t("basicData.OrderCancel"),
                                  value: 3,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.waybillStatus") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchForm.wayBillStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "wayBillStatus", $$v)
                                },
                                expression: "searchForm.wayBillStatus",
                              },
                            },
                            _vm._l(_vm.waybillStatusList, function (item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.label, value: item.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.waybillNumber") } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.searchForm.numberField,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "numberField",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.numberField",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.TheOrderNumber"
                                      ),
                                      value: "order_number",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.customerNum"
                                      ),
                                      value: "waybill_number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "basicData.search2000Rows"
                                  ),
                                  rows: 2,
                                  type: "textarea",
                                },
                                model: {
                                  value: _vm.searchNumber,
                                  callback: function ($$v) {
                                    _vm.searchNumber = $$v
                                  },
                                  expression: "searchNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticStyle: { "margin-top": "30px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.clickSearch },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v(_vm._s(_vm.$t("newOrder.reset")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "stats-row" }, [
        _c("div", { staticClass: "stat-card" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("basicData.InitialBalance"))),
          ]),
          _c(
            "div",
            { staticClass: "stat-value" },
            [
              _c("svg-icon", { attrs: { "icon-class": "money_bag" } }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.formatMoney(_vm.balanceStatistics.beginBalance))
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "stat-card" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("basicData.RechargeRefundTotal"))),
          ]),
          _c(
            "div",
            { staticClass: "stat-value" },
            [
              _c("svg-icon", { attrs: { "icon-class": "money_bag" } }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.formatMoney(_vm.balanceStatistics.rechargeAmount))
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "stat-card" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("basicData.ExpenditureTotal"))),
          ]),
          _c(
            "div",
            { staticClass: "stat-value" },
            [
              _c("svg-icon", { attrs: { "icon-class": "money_bag" } }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.formatMoney(_vm.balanceStatistics.expenseAmount))
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "stat-card" }, [
          _c("div", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("basicData.EndingBalance"))),
          ]),
          _c(
            "div",
            { staticClass: "stat-value" },
            [
              _c("svg-icon", { attrs: { "icon-class": "money_bag" } }),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.formatMoney(_vm.balanceStatistics.endBalance))
                ),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "stat-card" }, [
          _c(
            "div",
            { staticClass: "stat-label" },
            [
              _vm._v(" " + _vm._s(_vm.$t("basicData.OrderQuantity")) + " "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content:
                      _vm.$t("basicData.OrderQuantity") +
                      "：" +
                      _vm.$t(
                        "basicData.ItWillCountDeduplicationBasedOnSearchResults"
                      ),
                    placement: "top",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-warning-outline",
                    staticStyle: { "font-size": "18px", "margin-left": "10px" },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "stat-value" },
            [
              _c("svg-icon", { attrs: { "icon-class": "tongjibaobiao" } }),
              _c("span", [
                _vm._v(_vm._s(_vm.balanceStatistics.orderCount || 0)),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "table-toolbar" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleExport } },
                [_vm._v(_vm._s(_vm.$t("newOrder.export")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.openCustomColumn },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("orderCenterCont.CustomizeListColumn")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                },
                border: "",
              },
            },
            _vm._l(_vm.viewColumn, function (item, index) {
              return _c(
                "el-table-column",
                {
                  key: index,
                  attrs: {
                    label: item.label,
                    align: item.align,
                    prop: item.prop,
                  },
                },
                _vm._l(item.children, function (list, index1) {
                  return _c("el-table-column", {
                    key: index1,
                    attrs: {
                      label: list.label,
                      align: list.align,
                      prop: list.prop,
                      width: list.width,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              list.prop === "index"
                                ? _c("div", [
                                    _vm._v(
                                      " " + _vm._s(scope.$index + 1) + " "
                                    ),
                                  ])
                                : list.prop === "fundCategoryName"
                                ? _c("div", [
                                    scope.row.fundCategory === 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "fund-category",
                                            staticStyle: {
                                              background: "#409eff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[list.prop]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : scope.row.fundCategory === 2
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "fund-category",
                                            staticStyle: {
                                              background: "#f56c6c",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[list.prop]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : scope.row.fundCategory === 3
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "fund-category",
                                            staticStyle: {
                                              background: "#e6a23c",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[list.prop]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : list.prop === "expenseCategoryName"
                                ? _c("div", [
                                    scope.row[list.prop]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "fund-category",
                                            staticStyle: {
                                              border: "1px solid #409eff",
                                              color: "#409eff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[list.prop]) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      " " + _vm._s(scope.row[list.prop]) + " "
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.queryForm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("orderCenterCont.CustomizeListColumn"),
                visible: _vm.showCustomColumnDrawer,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                direction: "ltr",
                width: "600px",
                "custom-class": "demo-drawer",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showCustomColumnDrawer = $event
                },
              },
            },
            [
              _c("customColumn", {
                key: _vm.customColumnKey,
                ref: "customColumnRef",
                attrs: {
                  "new-column": _vm.newColumn,
                  "selected-prop": _vm.selectedProp,
                },
                on: { saveColumn: _vm.saveColumn },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.showCustomColumnDrawer = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.handleCustomColumn },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }